import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/_service/api.service';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { SessionService } from 'src/app/shared/_service/session.service';
import { forkJoin } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-main-home',
	templateUrl: './home.component.html',
})
export class MainHomeComponent implements OnInit {
	constructor(
		private api: ApiService,
		private auth: AuthService,
		private router: Router,
		private session: SessionService,
		private modalService: NgbModal,
	) {}

	@ViewChild('aCategory') aCategory: HTMLDivElement;
	@ViewChild('aSeries') aSeries: HTMLDivElement;

	error = '';
	jsonIn: any = {};
	jsonInAddTocart: any = { quantita: 0 };
	prodottiPerTipoGas;

	username = this.auth.getUser().username;

	isAdmin = this.auth.isAdmin;
	isAdminOrBackoffice = this.auth.isAdminOrBackoffice;
	isPartner = this.auth.isPartner;
	isSpedizioniere = this.auth.isSpedizioniere;
	isCliente = this.auth.isCliente;
	isAgente = this.auth.isAgente;
	containerizzazioneAttiva = this.auth.getUser().containerizzazioneOrdini;

	ngOnInit() {}

	stepQuantita(mode) {
		if (this.jsonInAddTocart.quantita > 0 && mode === '-') {
			this.jsonInAddTocart.quantita--;
		}
		if (this.jsonInAddTocart.quantita < 100 && mode === '+') {
			this.jsonInAddTocart.quantita++;
		}
	}

	cambioPassword() {
		this.error = '';

		if (!this.jsonIn.oldPassword) {
			this.error += 'Compile OLD PASSWORD <br>';
		}

		if (!this.jsonIn.newPassword) {
			this.error += 'Compile NEW PASSWORD <br>';
		}

		if (!this.jsonIn.newPasswordRepeat) {
			this.error += 'Compile NEW PASSWORD REPEAT <br>';
		}

		if (this.jsonIn.newPassword !== this.jsonIn.newPasswordRepeat) {
			this.error += 'Confirm password does not match. <br>';
		}

		if (this.error) {
			return;
		}

		this.api.cambioPassword(this.jsonIn).subscribe((res: any) => {
			if (res.esito === 'KO' && res.descrizione === 'vecchia.password.non.corretta') {
				this.error += 'Old password does not match. <br>';
			} else if (res.esito === 'OK') {
				this.router.navigate(['/logout']);
			}
		});
	}

	shopByCode(modal) {
		this.api.searchByProductCode(this.jsonInAddTocart.codiceCommerciale).subscribe((listaProdottoCommerciale: any) => {
			if (listaProdottoCommerciale.length === 1) {
				this.session.setCarrello(listaProdottoCommerciale[0].codiceTecnico, this.jsonInAddTocart.quantita, true).subscribe(() => {
					this.router.navigate(['/cart']);
				});
			} else if (listaProdottoCommerciale.length > 1) {
				this.prodottiPerTipoGas = listaProdottoCommerciale;
				this.modalService.open(modal);
			} else {
				alert('Product code not found.');
			}
		});
	}

	scegliTipoGas(prodottoCommerciale, modal) {
		this.session.setCarrello(prodottoCommerciale.codiceTecnico, this.jsonInAddTocart.quantita, true).subscribe(() => {
			this.router.navigate(['/cart']);
			modal.close();
		});
	}

	scrollTo(element) {
		element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}
}
